<script setup>
import { ref } from "vue";

const props = defineProps({
  copiedValue: {
    type: Boolean,
    default: false,
  },
  valueToCopy: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "sm",
  },
  showOnHover: {
    type: Boolean,
    default: false,
  },
});

const isCopied = ref(props.copiedValue);

const copyValue = async () => {
  isCopied.value = true;
  await navigator.clipboard.writeText(props.valueToCopy);
  setTimeout(() => {
    isCopied.value = false;
  }, 250);
};
</script>

<template>
  <button
    v-if="!isCopied"
    type="button"
    class="copy-value-button"
    :class="{ 'copy-value-button--on-hover': showOnHover }"
    aria-label="Copiar valor"
    @click.stop="copyValue"
  >
    <i v-tooltip="'Copiar'" class="fa-regular fa-copy hover-copy" :class="`text-${size}`"></i>
  </button>
  <button
    v-else
    type="button"
    class="copy-value-button"
    :class="{ 'copy-value-button--on-hover': showOnHover }"
    aria-label="Valor copiado"
    @click.stop
  >
    <i class="fa-solid fa-check grid-icon-primary" :class="`text-${size}`"></i>
  </button>
</template>
<style>
.hover-copy:hover {
  cursor: pointer;
}
.copy-value-button {
  appearance: none;
  background: transparent;
  border: 0;
  line-height: 1;
  padding: 0;
}
.copy-value-button--on-hover {
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}
.copy-value-container:hover .copy-value-button--on-hover,
.copy-value-button--on-hover:focus {
  opacity: 1;
}
</style>
